export default class ViewCounter {

    /**
     * Creates an instance of view count element
     * and fills counter
     *
     * @param {opt} opt configuration object.
     * @example { selector: '#counter', entityKey: '3848382', apiDns: 'https://counter24.luxnet.ua/'}
     * */
    constructor(opt) {
        const elem = document.querySelector(opt.selector);

        if (!(elem && opt.entityKey && opt.apiDns)) {
            console.info(`ViewCounter initialization error. Wrong configuration.`);
            return;
        }

        this.elem = elem;
        this.entityKey = opt.entityKey;
        this.apiDns = opt.apiDns;

        /* Initialize the widget */
        this._init();
    }

    async _init() {
        this.requestViewCount(this.entityKey);
    }

    /**
     * Method increases or creates new counter with key
     * @see https://counter24.luxnet.ua/api-doc/
     * */
    async requestViewCount() {
        try {
            const res = await fetch(`${this.apiDns}counter/${this.entityKey}`, {
                method: 'POST'
            });
            const data = await res.json();
            this.elem.innerHTML = data.value ? data.value : 0;
        } catch (e) {
            console.error('Failed to fetch view counter data', e);
            this.elem.innerHTML = 0;
        }
    }
}